<h1 mat-dialog-title [class.red_text]="data.type === alertTypeEnum.ERROR">{{data.title}}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" tabindex="1">Ok</button>
</div>